"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Carrier {
}
exports.Carrier = Carrier;
//# sourceMappingURL=Carrier.js.map